import api from './api';

export const getEmployees = (search = '', departmentId = '') => {
  let url = '/employees';
  
  const params = new URLSearchParams();
  if (search) params.append('search', search);
  if (departmentId) params.append('department_id', departmentId);
  
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  
  return api.get(url);
};

export const getEmployee = (id) => api.get(`/employees/${id}`);
// Alias for getEmployee for backward compatibility
export const getEmployeeById = (id) => getEmployee(id);
export const createEmployee = (data) => api.post('/employees', data);
export const updateEmployee = (id, data) => api.post(`/employees/${id}?_method=PUT`, data);
export const deleteEmployee = (id) => api.delete(`/employees/${id}`);
export const uploadProfile = (id, file) => {
  const fd = new FormData();
  fd.append('profile_image', file);
  return api.post(`/employees/${id}/upload-profile`, fd);
};

export const importEmployees = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post('/employees/import', fd, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(response => {
    if (response.data.message) {
      return response.data;
    }
    throw new Error('Failed to import employees');
  }).catch(error => {
    throw error.response?.data?.error || 'Failed to import employees';
  });
};

/**
 * Get appraisal history for an employee
 * @param {number|string} employeeId - The ID of the employee
 * @returns {Promise} Promise that resolves to the appraisal history data
 */
export const getEmployeeAppraisalHistory = (employeeId) => {
  return api.get(`/employees/${employeeId}/appraisal-history`);
};
